export default [

     {
          path: '/risk-supervisor-setting',
          name: 'RiskSupervisorSetting',
          component: () => import("@/views/Page/RiskSupervisorSetting/RiskSupervisorSetting.vue"),
           meta: {
               title: 'GRC | RiskSupervisorSetting',
          },
     }
];